import { $wgsl } from "../../wgsl-preprocessor/wgsl-preprocessor";
import SAOShader from "./SAO.wgsl";
import pack_depth from "../chunks/pack_depth.wgsl";

const USE_MIPMAP = true;

export function getSaoShader() {
  return $wgsl(SAOShader, { pack_depth, USE_MIPMAP });
}